import { type ReactNode } from 'react';
import { YouTubeEmbed } from '@/components/ui/youtube-embed';
import { LoomEmbed } from '@/components/ui/loom-embed';
import type { FeedEmbed } from './types';

type Props = { embeds: FeedEmbed[] };

function EmbedItem({ embed }: { embed: FeedEmbed }): ReactNode {
  if (embed.provider === 'youtube')
    return <YouTubeEmbed videoId={embed.video_id} nativeControls />;
  if (embed.provider === 'loom') return <LoomEmbed videoId={embed.video_id} />;
  return null;
}

export function FeedCardEmbeds({ embeds }: Props): ReactNode {
  if (!embeds || embeds.length === 0) return null;
  return (
    <div className="mt-md space-y-sm">
      {embeds.map((embed, i) => (
        <EmbedItem
          key={`${embed.provider}-${embed.video_id}-${i}`}
          embed={embed}
        />
      ))}
    </div>
  );
}
